import { filters } from '../components/map-filter/mapFilterConfig';

export const getSiteIconBySiteType = (siteType: string): React.FunctionComponent | undefined => {
  const icon = filters.find((item) => item.id === siteType)?.icon;

  return icon;
};
